/**
 * Topic color definitions for Study Path Map
 * Each topic has primary, secondary colors and glow effect
 */

export interface TopicColors {
  primary: string;
  secondary: string;
  glow: string;
  gradient: string;
}

export const topicColors: Record<string, TopicColors> = {
  'filosofie': {
    primary: '#8b5cf6',
    secondary: '#a78bfa',
    glow: 'purple',
    gradient: 'from-purple-500 to-purple-700'
  },
  'psychologie': {
    primary: '#ef4444',
    secondary: '#f87171',
    glow: 'red',
    gradient: 'from-red-500 to-red-700'
  },
  'sociologie': {
    primary: '#14b8a6',
    secondary: '#2dd4bf',
    glow: 'teal',
    gradient: 'from-teal-500 to-teal-700'
  },
  'pravo': {
    primary: '#f97316',
    secondary: '#fb923c',
    glow: 'orange',
    gradient: 'from-orange-500 to-orange-700'
  },
  'politologie': {
    primary: '#6366f1',
    secondary: '#818cf8',
    glow: 'indigo',
    gradient: 'from-indigo-500 to-indigo-700'
  },
  'ekonomie': {
    primary: '#22c55e',
    secondary: '#4ade80',
    glow: 'green',
    gradient: 'from-green-500 to-green-700'
  },
  'evropska-unie': {
    primary: '#3b82f6',
    secondary: '#60a5fa',
    glow: 'blue',
    gradient: 'from-blue-500 to-blue-700'
  },
  'moderni-historie': {
    primary: '#f59e0b',
    secondary: '#fbbf24',
    glow: 'amber',
    gradient: 'from-amber-500 to-amber-700'
  }
};

/**
 * Get colors for a specific topic
 */
export function getTopicColors(topicId: string): TopicColors {
  return topicColors[topicId] || topicColors['filosofie']; // Default to filosofie colors
}

/**
 * Get topic color for SVG gradient
 */
export function getTopicGradientColors(topicId: string): { start: string; end: string } {
  const colors = getTopicColors(topicId);
  return {
    start: colors.primary,
    end: colors.secondary
  };
}
